import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { PhonebookDialogComponent } from '../phonebook-dialog/phonebook-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-phonebook-button',
    imports: [
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        TranslateModule
    ],
    templateUrl: './phonebook-button.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./phonebook-button.component.css']
})
export class PhonebookButtonComponent {

  @Input() customerId!: string;
  @Input() serverId!: string;

  constructor(private dialog: MatDialog) {}

  openPhonebook() {
    this.dialog.open(PhonebookDialogComponent, {
      width: '600px',
      data: {
        customerId: this.customerId,
        serverId: this.serverId
      }
    });
  }
}